<!--
 * @Author: qinzhenpen qzp1807@126.com
 * @Date: 2023-09-28 14:48:30
 * @LastEditors: qinzhenpen qzp1807@126.com
 * @LastEditTime: 2025-03-13 18:22:08
 * @FilePath: \tianze_web\src\layout\components\AppMain.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue